<div class="profile" *ngIf="session.loggedInUser$ | async as user">
  <div *ngIf="!!user">
    <div class="d-flex justify-content-between gap-32">
      <div class="d-flex align-items-center gap-16">
        <div class="d-flex justify-content-center align-items-center circle">
          {{ user.email | nameInitials }}
        </div>
        <div>
          <div>{{ user.email }}</div>
        </div>
      </div>
      <app-button appDialogClose size="circle-small">
        <app-icon>close</app-icon>
      </app-button>
    </div>
    <app-divider class="w-100 mt-4 mb-2"></app-divider>
    <app-button variant="ghost-primary" (click)="manageCookies()">
      Gerenciar cookies
    </app-button>
    <app-button variant="ghost-primary" (click)="logout()">
      Sair da conta
    </app-button>
  </div>
</div>
